import IconsTextNavigation from 'components/global/IconsTextNavigation'
import RequiredDetailsModal from 'pages/Events/Views/Common/Modals/RequiredDetails'
import React, { useEffect, useState } from 'react'
import { creationEventStore } from 'state/event/eventCreationStore'

const RequiredDetails: React.FC = () => {
  const [requiredDetailsModal, setRequiredDetailsModal] =
    useState<boolean>(false)
  const [isAdded, setIsAdded] = useState<boolean>(false)
  const { requiredDetails, setRequiredDetails } = creationEventStore(store => ({
    requiredDetails: store.requiredDetails,
    setRequiredDetails: store.setRequiredDetails,
  }))

  useEffect(() => {
    const hasSelected = Object.keys(requiredDetails).some(category =>
      requiredDetails[category].some(item => item.value === true),
    )
    setIsAdded(hasSelected)
  }, [requiredDetails])

  return (
    <>
      <div onClick={() => setRequiredDetailsModal(true)}>
        <IconsTextNavigation
          iconName="CheckCircle"
          heading="Required Details"
          isCompleted={isAdded}
        />
      </div>

      {requiredDetailsModal && (
        <RequiredDetailsModal
          openModal={requiredDetailsModal}
          closeModal={setRequiredDetailsModal}
          requiredDetails={requiredDetails}
          setRequiredDetails={setRequiredDetails}
        />
      )}
    </>
  )
}

export default RequiredDetails
